export interface MapPlace {
  id: string;
  name: string;
  value: string;
  address: string;
  latLng: { lat: number; lng: number };
}

interface SearchResponse {
  status: number;
  data?: Array<{
    id: string;
    title: string;
    address: string;
    location: { lat: number; lng: number };
  }>;
}

let requestId = 0;

// Reuse the browser Key loaded by the map SDK. JSONP avoids cross-origin XHR.
export function searchTencentPlaces(city: string, keyword: string): Promise<MapPlace[]> {
  return new Promise((resolve, reject) => {
    const sdk = document.getElementById("tencent-map-sdk") as HTMLScriptElement | null;
    const key = sdk && new URL(sdk.src).searchParams.get("key");
    if (!key) {
      reject(new Error("地图 Key 未配置，请联系管理员"));
      return;
    }

    const callbackName = `__chandonMapSearch_${++requestId}`;
    const callbacks = window as any;
    const script = document.createElement("script");
    let settled = false;
    const cleanup = () => {
      window.clearTimeout(timer);
      script.onload = null;
      script.onerror = null;
      if (script.parentNode) script.parentNode.removeChild(script);
      delete callbacks[callbackName];
    };
    const fail = (message: string) => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(new Error(message));
    };
    const timer = window.setTimeout(() => fail("地图搜索超时，请重试"), 10000);

    callbacks[callbackName] = (response: SearchResponse) => {
      if (settled) return;
      if (!response || response.status !== 0) {
        fail(`地图搜索失败（错误码：${response ? response.status : "未知"}），请重试或联系管理员`);
        return;
      }
      if (!Array.isArray(response.data)) {
        fail("地图搜索返回异常，请重试");
        return;
      }
      const places = response.data
        .filter(place => place && place.location &&
          Number.isFinite(place.location.lat) && Number.isFinite(place.location.lng))
        .map(place => ({
          id: place.id,
          name: place.title,
          value: place.title,
          address: place.address,
          latLng: { lat: place.location.lat, lng: place.location.lng },
        }));
      settled = true;
      cleanup();
      resolve(places);
    };

    const params = new URLSearchParams({
      key,
      keyword,
      boundary: `region(${city},0)`,
      page_size: "20",
      page_index: "1",
      output: "jsonp",
      callback: `window.${callbackName}`,
    });
    script.src = `https://apis.map.qq.com/ws/place/v1/search?${params.toString()}`;
    script.charset = "utf-8";
    script.async = true;
    script.onerror = () => fail("地图搜索网络异常，请重试");
    script.onload = () => fail("地图搜索返回异常，请重试");
    document.head.appendChild(script);
  });
}
